import { AppProvider } from './contexts/app.context';
import { Main } from './pages/main.page';
import CookieBanner from './pages/policies/cookiesbanner';

function App() {
  return (
    <AppProvider>
        <Main></Main>
        <CookieBanner/>
    </AppProvider>
  );
}

export default App;
